@if (!hidden()) {
  <div class="inputs" [class.range]="showTimeRange()" (focusout)="touch.emit()">
    <onyx-timepicker-input
      [label]="label() || !!labelTo()"
      [hint]="hint()"
      [variant]="variant()"
      [size]="size()"
      [showClockIcon]="showClockIcon()"
      [value]="value_().from ?? {}"
      [disabled]="disabled()"
      [required]="required()"
      [invalid]="isInvalid() || forceError()"
      (valueChange)="changeValue('from', $event)"
    ></onyx-timepicker-input>

    @if (showTimeRange()) {
      <div
        class="separator size-{{ size() }}"
        [class.label]="label() || labelTo()"
      >
        -
      </div>

      <onyx-timepicker-input
        [label]="labelTo() || !!label()"
        [variant]="variant()"
        [size]="size()"
        [showClockIcon]="showClockIcon()"
        [value]="value_().to ?? {}"
        [disabled]="disabled()"
        [required]="required()"
        [invalid]="isInvalid() || forceError()"
        (valueChange)="changeValue('to', $event)"
      ></onyx-timepicker-input>
    }
  </div>

  @let control = formField() ?? formControl();
  @if (control && showErrors()) {
    <onyx-error [errors]="[control]" variant="control"></onyx-error>
  }
}
